export enum HMDAExportType {
    TextPipeDelimited = 0,
    Excel = 1,
    ExcelTransposed = 2,
}
